import React from "react";
import { withTranslation } from "react-i18next";
import { Box } from "@mui/material";
import SampleView from "../../components/overview/devices/sampleView/SampleView";

const SampleViewContainer = ({ }) => {
  return (
    <Box sx={{ height: "100%", overflow: "auto" }}>
      <SampleView />
    </Box>
  );
};

export default withTranslation("common")(SampleViewContainer);
